export const TERMS = "terms";
export const TERMS_VAR = `$${TERMS}`;

export const SIZE = "size";
export const SIZE_VAR = `$${SIZE}`;

export const FROM = "from";
export const FROM_VAR = `$${FROM}`;

export const CONCEPT = "concept";
export const CONCEPT_VAR = `$${CONCEPT}`;
